export const messages = {
  en: {
    staff: {
      queryCondition: 'Query Conditions',
      inputStaffName: 'Please enter staff name',
      inputPhone: 'Please enter phone number',
      inputStaffId: 'Please enter staff ID',
      query: 'Query',
      reset: 'Reset',
      staffManagement: 'Merchant Operation Staff',
      add: 'Add',
      staffId: 'Staff ID',
      name: 'Name',
      phone: 'Phone',
      relatedOrg: 'Related Organization',
      position: 'Position',
      email: 'Email',
      address: 'Address',
      gender: 'Gender',
      operation: 'Operation',
      edit: 'Edit',
      resetPassword: 'Reset Password',
      delete: 'Delete',
      detail: 'Detail',
      male: 'Male',
      female: 'Female',
      tip: 'Tip: The default password for new staff is 123456. After assigning community permissions and associating roles, they can log in.'
    },
    resetStaffPwd: {
      confirmOperation: 'Please confirm your operation!',
      confirmReset: 'Confirm to reset password?',
      cancel: 'Cancel',
      confirm: 'Confirm',
      resetSuccess: 'Password reset successful, the new password is {pwd}. Please change it promptly.'
    },
    editStaff: {
      editStaff: 'Edit Staff',
      name: 'Name',
      inputName: 'Required, please enter staff name',
      position: 'Position',
      selectPosition: 'Required, please select position',
      email: 'Email',
      inputEmail: 'Optional, please enter email',
      phone: 'Phone',
      inputPhone: 'Required, please enter phone number',
      gender: 'Gender',
      selectGender: 'Required, please select gender',
      male: 'Male',
      female: 'Female',
      address: 'Address',
      inputAddress: 'Please enter home address',
      uploadPhoto: 'Upload Photo',
      cancel: 'Cancel',
      confirm: 'Confirm',
      nameValidate: 'Username must be 2-10 characters',
      phoneRequired: 'Phone number is required',
      genderRequired: 'Gender is required',
      addressValidate: 'Address is required and cannot exceed 200 characters',
      editSuccess: 'Edit successful',
      imageSizeLimit: 'Image size cannot exceed 2MB'
    },
    deleteStaff: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete? Before deleting staff, please ensure all related approval processes are completed. Deleted processes cannot continue, please operate carefully!',
      cancel: 'Cancel',
      confirm: 'Confirm Delete',
      deleteSuccess: 'Delete successful'
    }
  },
  zh: {
    staff: {
      queryCondition: '查询条件',
      inputStaffName: '请输入员工名称',
      inputPhone: '请输入手机号',
      inputStaffId: '请输入员工ID',
      query: '查询',
      reset: '重置',
      staffManagement: '商户运营员工管理',
      add: '添加',
      staffId: '员工编号',
      name: '名称',
      phone: '手机号',
      relatedOrg: '关联组织',
      position: '岗位',
      email: '邮箱',
      address: '地址',
      gender: '性别',
      operation: '操作',
      edit: '修改',
      resetPassword: '重置密码',
      delete: '删除',
      detail: '详情',
      male: '男',
      female: '女',
      tip: '温馨提示：新添加员工默认密码为123456，角色权限分配小区并且角色关联员工后可登录'
    },
    resetStaffPwd: {
      confirmOperation: '请确认您的操作!',
      confirmReset: '确认是否重置密码!',
      cancel: '点错了',
      confirm: '确认重置',
      resetSuccess: '修改密码成功，密码为{pwd}请及时修改密码'
    },
    editStaff: {
      editStaff: '修改员工',
      name: '名称',
      inputName: '必填，请填写员工名称',
      position: '员工岗位',
      selectPosition: '必填，请选择岗位',
      email: '邮箱',
      inputEmail: '可选，请填写员工名称',
      phone: '手机',
      inputPhone: '必填，请填写手机号码',
      gender: '性别',
      selectGender: '必填，请选择员工性别',
      male: '男',
      female: '女',
      address: '住址',
      inputAddress: '请填写家庭住址',
      uploadPhoto: '上传照片',
      cancel: '取消',
      confirm: '修改',
      nameValidate: '用户名长度必须在2位至10位',
      phoneRequired: '手机号不能为空',
      genderRequired: '性别不能为空',
      addressValidate: '地址不能为空且长度不能超过200位',
      editSuccess: '修改成功',
      imageSizeLimit: '图片大小不能超过 2MB'
    },
    deleteStaff: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确认是否删除，删除员工前请确认员工已完成相关审批流程，删除后相关流程将无法继续进行，请慎重操作！',
      cancel: '点错了',
      confirm: '确认删除',
      deleteSuccess: '删除成功'
    }
  }
}